import React from 'react';
import { Menu, Button } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { BulbOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { useTheme } from '../../context/ThemeContext';
import './Nav.less';

const Nav: React.FC = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { toggleTheme, theme } = useTheme();

  const menuItems: MenuProps['items'] = [
    {
      key: '/',
      label: (
        <Link to="/">首页</Link>
      ),
    },
    {
      key: '/about',
      label: (
        <Link to="/about">关于我们</Link>
      ),
    },
  ];

  return (
    <nav className="nav-container">
      <div className="nav-content">
        <Menu
          mode="horizontal"
          selectedKeys={[currentPath]}
          items={menuItems}
          className="nav-menu"
        />
        <Button
          type="primary"
          icon={<BulbOutlined />}
          onClick={toggleTheme}
          className="theme-toggle-btn"
          title={theme === 'light' ? '切换到暗色主题' : '切换到亮色主题'}
        >
          {theme === 'light' ? '暗色' : '亮色'}
        </Button>
      </div>
    </nav>
  );
};

export default Nav;